import { apiAction } from '@store/middlewares/api/ApiActionCreators';
import { ENDPOINT_GET_FAX_COUNTS } from '@utilities/apiConstants';
import { FaxCountRequestPayload, FaxCountResponse } from '@data/faxManagement/types/FaxManagement.types';
import { GET_FAX_COUNT } from '@store/actions/types';
import ApiService from '@utilities/apiEndpoints/ApiService';
import { ApiActionPayload } from '@interfaces/ApiAction/ApiActionPayload';
import { ErrorStatusState } from '@interfaces/ErrorStatus/ErrorStatusState';

export function getFaxCount(overrides?: Partial<ApiActionPayload<FaxCountRequestPayload, ErrorStatusState, FaxCountResponse>>) {
	return apiAction<FaxCountRequestPayload, ErrorStatusState, FaxCountResponse>({
		url: ENDPOINT_GET_FAX_COUNTS,
		method: 'GET',
		label: GET_FAX_COUNT,
		apiService: ApiService.DS,
		includeAccessToken: true,
		shouldDisableLoadIndicator: true,
		...overrides,
	});
}
